import styled from 'styled-components';
import { ContextMenuContainer } from '../ContextMenu';

export const Container = styled.div`
  flex-direction: row;
  height: 34px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DropdownButton = styled.button`
  height: 100%;
  max-width: 30%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.v2_secondary};
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) =>
      theme.colors.v2_secondary || theme.colors.v2_secondary};
  }

  :active {
    box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.2);
    outline: none;
    transform: scale(0.98);
  }

  transition: all 150ms ease;
  border: none;
  padding: 0 8px;
`;

export const TimePickerContainer = styled(ContextMenuContainer)`
  padding: 12px;
  width: 280px;
  height: auto;
  max-height: 300px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const TimeRow = styled.div`
  flex-direction: row;
  display: flex;
  height: auto;
  gap: 12px;
`;

export const TimeCol = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
  position: relative;

  &:first-child::after {
    content: ':';
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    font-weight: bold;
  }
`;

export const TimeList = styled.ol`
  list-style-type: none;
  max-height: 180px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background || '#f1f1f1'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.v2_secondary || '#888'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.v2_secondary || '#555'};
  }
`;
